export default __webpack_public_path__ + "static/cndf-cilium-dsr2-e108ce29f1e669c299006b7f43c7cb71.jpg";